// extracted by mini-css-extract-plugin
export var link = "_tz-0";